"use client";

// DEPRECATED: This component is kept for backwards compatibility
// Use Clerk's <SignInButton> component instead from @clerk/nextjs
import { GoogleIcon } from "../icons/GoogleIcon";

interface GoogleSignInButtonProps {
  label?: string;
  redirectTo?: string;
  callbackUrl?: string;
  className?: string;
  variant?: "primary" | "secondary" | "white";
}

export function GoogleSignInButton({
  label = "Sign in with Google",
  redirectTo,
  callbackUrl,
  className = "",
  variant = "white"
}: GoogleSignInButtonProps) {
  const handleGoogleSignIn = () => {
    console.warn('[DEPRECATED] GoogleSignInButton is deprecated. Use Clerk SignInButton instead.');
    // No-op - component is deprecated
  };

  const baseStyles = "inline-flex items-center justify-center gap-3 px-8 py-4 rounded-lg font-semibold transition-all duration-200 transform hover:scale-105 shadow-lg";

  const variantStyles = {
    primary: "bg-gradient-to-r from-orange-400 to-pink-400 text-white hover:from-violet-600 hover:to-purple-700 shadow-violet-500/25",
    secondary: "bg-white/10 backdrop-blur-sm border border-white/20 text-white hover:bg-white/20",
    white: "bg-white text-gray-900 border border-gray-300 hover:bg-gray-50 hover:border-gray-400 shadow-gray-300/50"
  };

  return (
    <button
      onClick={handleGoogleSignIn}
      className={`${baseStyles} ${variantStyles[variant]} ${className}`}
    >
      <GoogleIcon className="w-5 h-5" />
      {label}
    </button>
  );
}